import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full p-6" }
const _hoisted_2 = { class: "text-2xl font-bold mb-2" }
const _hoisted_3 = { class: "text-muted-foreground mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbNavigation = _resolveComponent("BreadcrumbNavigation")!
  const _component_AdminDashboard = _resolveComponent("AdminDashboard")!
  const _component_EmailTemplateManagement = _resolveComponent("EmailTemplateManagement")!
  const _component_UserRoleManagement = _resolveComponent("UserRoleManagement")!
  const _component_SystemConfiguration = _resolveComponent("SystemConfiguration")!
  const _component_AuditLogs = _resolveComponent("AuditLogs")!
  const _component_EmailTemplateTest = _resolveComponent("EmailTemplateTest")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BreadcrumbNavigation, {
      activeView: _ctx.combinedActiveView,
      onNavigate: _ctx.handleNavigation
    }, null, 8, ["activeView", "onNavigate"]),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.combinedActiveView === '' ? 'Administration' : _ctx.viewTitles[_ctx.combinedActiveView]), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.combinedActiveView === '' ? 'Manage system settings, user roles, and monitor system activity' : _ctx.viewSubtitles[_ctx.combinedActiveView]), 1),
    (_ctx.combinedActiveView === '')
      ? (_openBlock(), _createBlock(_component_AdminDashboard, {
          key: 0,
          onNavigate: _ctx.handleNavigation
        }, null, 8, ["onNavigate"]))
      : _createCommentVNode("", true),
    (_ctx.combinedActiveView === 'email-templates')
      ? (_openBlock(), _createBlock(_component_EmailTemplateManagement, {
          key: 1,
          onNavigate: _ctx.handleNavigation
        }, null, 8, ["onNavigate"]))
      : _createCommentVNode("", true),
    (_ctx.combinedActiveView === 'user-roles')
      ? (_openBlock(), _createBlock(_component_UserRoleManagement, {
          key: 2,
          onNavigate: _ctx.handleNavigation
        }, null, 8, ["onNavigate"]))
      : _createCommentVNode("", true),
    (_ctx.combinedActiveView === 'system-config')
      ? (_openBlock(), _createBlock(_component_SystemConfiguration, {
          key: 3,
          onNavigate: _ctx.handleNavigation
        }, null, 8, ["onNavigate"]))
      : _createCommentVNode("", true),
    (_ctx.combinedActiveView === 'audit-logs')
      ? (_openBlock(), _createBlock(_component_AuditLogs, {
          key: 4,
          onNavigate: _ctx.handleNavigation
        }, null, 8, ["onNavigate"]))
      : _createCommentVNode("", true),
    (_ctx.combinedActiveView === 'email-template-test')
      ? (_openBlock(), _createBlock(_component_EmailTemplateTest, {
          key: 5,
          onNavigate: _ctx.handleNavigation
        }, null, 8, ["onNavigate"]))
      : _createCommentVNode("", true)
  ]))
}